import { ReactNode, useCallback, useState } from "react";
import { useLocation } from "@tanstack/react-router";
import { Text } from "components/text";
import { useSearchParams } from "~/hooks/useSearchParams";
import { TitleEditor } from "./TitleEditor";

interface TabHeaderProps {
  title: string;
  subtitle: string | ReactNode;
  isEditable?: boolean;

  onEdit?(value: string): void;
}

export const TabHeader = ({
  title,
  subtitle,
  onEdit,
  isEditable,
}: TabHeaderProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isEditing] = useState(() => searchParams.get("newProject") === "true");
  const location = useLocation();

  const handleChange = useCallback(
    (value: string) => {
      onEdit?.(value);

      if (searchParams.get("newProject")) {
        // Removes the newProject query param
        setSearchParams(new URLSearchParams(), {
          replace: true,
          state: location.state,
        });
      }
    },
    [onEdit, setSearchParams, location, searchParams],
  );

  return (
    <div>
      <TitleEditor
        value={title}
        autoFocus={isEditing}
        onChange={handleChange}
        disabled={!isEditable}
      />
      <Text
        as="div"
        variant="subtle"
        className="pt-1"
        data-testid="header-subtitle"
      >
        {subtitle}
      </Text>
    </div>
  );
};
